import { defineComponent as _defineComponent } from 'vue'


  
  const __default__ = {
    name: 'ProgressBar',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    percent: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: '#e3003a',
    },
  },
  setup(__props) {

const props = __props;

  

return { __sfc: true,props }
}

})